import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';

export default function ConfiguracaoResgates() {
    const [configuracao, setConfiguracao] = useState(null);
    const [loading, setLoading] = useState(true);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        carregarConfiguracao();
    }, []);

    async function carregarConfiguracao() {
        try {
            setLoading(true);
            const response = await api.get('/api/configuracoes');
            setConfiguracao(response.data);
        } catch (error) {
            console.error('Erro ao carregar configuração:', error);
            toast.error('Erro ao carregar configuração');
        } finally {
            setLoading(false);
        }
    }

    async function atualizarConfiguracao(bloquearResgate) {
        try {
            setSalvando(true);
            const response = await api.put(`/api/configuracoes/${configuracao.id}`, {
                bloquearResgate,
            });
            setConfiguracao(response.data);
            toast.success(
                bloquearResgate
                    ? 'Resgates bloqueados com sucesso'
                    : 'Resgates desbloqueados com sucesso'
            );
        } catch (error) {
            console.error('Erro ao atualizar configuração:', error);
            toast.error(
                error.response?.data?.erro || 'Erro ao atualizar configuração'
            );
        } finally {
            setSalvando(false);
        }
    }

    if (loading) {
        return (
            <Container fluid>
                <h4 className="pt-3 pb-3 f-black">Configuração de Resgates</h4>
                <hr className="hr-loja mt-0 mb-4" />
                <div className="text-center">
                    <span>
                        Carregando
                        <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                </div>
            </Container>
        );
    }

    if (!configuracao) {
        return (
            <Container fluid>
                <h4 className="pt-3 pb-3 f-black">Configuração de Resgates</h4>
                <hr className="hr-loja mt-0 mb-4" />
                <div className="text-center">
                    <span>Configuração não encontrada</span>
                </div>
            </Container>
        );
    }

    return (
        <Container fluid>
            <h4 className="pt-3 pb-3 f-black text-center">Configuração de Resgates</h4>
            <hr className="hr-loja mt-0 mb-4" />
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card>
                        <Card.Body className="text-center">
                            <h5 className="mb-4">Bloqueio de Resgates</h5>
                            <p className="text-muted mb-4">
                                Quando ativado, todos os resgates serão bloqueados
                                temporariamente. Os parceiros verão um popup informando sobre a
                                indisponibilidade do resgate ao tentar confirmar um resgate.
                            </p>
                            <div className="mb-4">
                                <strong>
                                    Status atual:{' '}
                                    {configuracao.bloquearResgate ? (
                                        <span className="text-danger">BLOQUEADO</span>
                                    ) : (
                                        <span className="text-success">LIBERADO</span>
                                    )}
                                </strong>
                            </div>
                            <div>
                                {configuracao.bloquearResgate ? (
                                    <Button
                                        variant="success"
                                        onClick={() => atualizarConfiguracao(false)}
                                        disabled={salvando}
                                        size="lg"
                                    >
                                        {salvando ? (
                                            <>
                                                <i className="fas fa-circle-notch fa-spin mr-2"></i>
                                                Salvando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-unlock mr-2"></i>
                                                Desbloquear Resgates
                                            </>
                                        )}
                                    </Button>
                                ) : (
                                    <Button
                                        variant="danger"
                                        onClick={() => atualizarConfiguracao(true)}
                                        disabled={salvando}
                                        size="lg"
                                    >
                                        {salvando ? (
                                            <>
                                                <i className="fas fa-circle-notch fa-spin mr-2"></i>
                                                Salvando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-lock mr-2"></i>
                                                Bloquear Resgates
                                            </>
                                        )}
                                    </Button>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

